import {AxiosInstance} from 'axios';
import {Action, Reducer} from 'redux';
import {ThunkAction} from 'redux-thunk';

type RootState = any;

enum UIStoreTypes {
	SET_LEFT_RAIL = 'SET_LEFT_RAIL',
}

interface SetLeftRail extends Action<UIStoreTypes.SET_LEFT_RAIL> {
	payload: boolean;
}

type UIStoreActionType = SetLeftRail;

type UIStoreActions = {
	readonly setLeftRail: (newstate: boolean) => SetLeftRail;
};

type UIStoreState = {
	readonly leftRailOpen: boolean;
};

// thunk result type: ThunkAction<[Return Type], [Store Type], [Extra Arg Type], [Action Type(s)]>

type UIStoreResult<R> = ThunkAction<Promise<R>, RootState, AxiosInstance, UIStoreActionType>;

interface IUIStore {
	readonly types: typeof UIStoreTypes;
	readonly actions: UIStoreActions;
	readonly state: UIStoreState;
	readonly reducer: Reducer<UIStoreState, UIStoreActionType>;

	readonly setLeftRail: (newstate: boolean) => UIStoreResult<SetLeftRail>;
}

export default IUIStore;
export {UIStoreTypes, SetLeftRail, UIStoreActionType, UIStoreActions, UIStoreState};
